// extracted by mini-css-extract-plugin
module.exports = {"emptyCalendar":"styles_emptyCalendar__BTs33","scrollbars":"styles_scrollbars___m1nr","slideInSearchBar":"styles_slideInSearchBar__DVylB"};